enum ConnectionsProgramStatus {
  CONFIGURATION = "CONFIGURATION",
  ENROLLMENT = "ENROLLMENT",
  PROFILE = "PROFILE",
  EXHIBITOR_REQUEST = "EXHIBITOR_REQUEST",
  ADD_TO_SCHEDULE = "ADD_TO_SCHEDULE",
  VIEW_SCHEDULE = "VIEW_SCHEDULE",
  IN_PROGRESS = "IN_PROGRESS",
  FEEDBACK = "FEEDBACK",
  REIMBURSEMENT = "REIMBURSEMENT",
  COMPLETED = "COMPLETED"
}

enum ConnectionsProgramStatusByValue {
  CONFIGURATION = 0,
  ENROLLMENT,
  PROFILE,
  EXHIBITOR_REQUEST,
  ADD_TO_SCHEDULE,
  VIEW_SCHEDULE,
  IN_PROGRESS,
  FEEDBACK,
  REIMBURSEMENT,
  COMPLETED
}

namespace ConnectionsProgramStatus {
  export function isBetweenEnrollmentAndInProgress(status?: ConnectionsProgramStatus): boolean {
    if (!status) return false;
    const statusValue = ConnectionsProgramStatusByValue[status];
    return (
      statusValue >= ConnectionsProgramStatusByValue.ENROLLMENT &&
      statusValue <= ConnectionsProgramStatusByValue.IN_PROGRESS
    );
  }
  export function isEnrollmentStateStarted(status?: ConnectionsProgramStatus): boolean {
    if (!status) return false;
    const statusValue = ConnectionsProgramStatusByValue[status];
    return statusValue >= ConnectionsProgramStatusByValue.ENROLLMENT;
  }
}

export default ConnectionsProgramStatus;
